{
  "app": {
    "notification": "Notification",
    "next": "Next",
    "login": {
      "title": "RDA Member Login",
      "email": "Email",
      "emailRequired": "Email is required.",
      "emailValidate": "Not a available Email.",
      "password": "Password",
      "passwordRequired": "Password is required.",
      "button": "Login",
      "showPassword": "Show Password",
      "registerTip": "Not a member yet?",
      "registerLink": "Register now.",
      "forgotPassword": "Forgot your password?",
      "privacyLabel": "Agree to Site ",
      "tcLink": "Terms & Conditions",
      "privacyAnd": " and ",
      "ppLink": "Privacy Policy",
      "tcAndPpLink": "Terms & Conditions and Privacy Policy",
      "privacyRequired": "You must agree to the Terms & Conditions and Privacy Policy.",
      "tcTitle": "Terms & Conditions",
      "ppTitle": "Privacy Policy",
      "scrollToAccept": "Scroll to the bottom to accept",
      "accept": "Accept",
      "close": "Close",
      "decline": "Decline",
      "loading": "Loading..."
    },
    "forgotPassword": {
      "title": "Reset Password",
      "forgotYourPassword": "Forgot your password?",
      "email": "Email address",
      "emailRequired": "Email is required",
      "emailValidate": "Invalid email address",
      "sendCode": "Send verification code",
      "backToLogin": "Back to Login",
      "codeSentMessage": "Verification Code has been sent to your email address. Please enter the verification code to continue.",
      "cannotReceiveCode": "Unable to receive?",
      "verificationCode": "Verification Code",
      "codeRequired": "Code is required",
      "newPassword": "New Password",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 6 characters long",
      "confirmPassword": "Confirm New Password",
      "confirmPasswordRequired": "Please fill",
      "passwordsDoNotMatch": "Passwords do not match",
      "showPassword": "Show Password",
      "resetPassword": "Confirm",
      "codeSent": "Verification code has been sent to your email.",
      "passwordUpdatedSuccessfully": "Password has been updated successfully.",
      "back": "Back"
    },
    "navbar": {
      "schedule": "Schedule",
      "availability": "Availability",
      "leaveRequest": "Leave",
      "accountSetting": "Account Setting",
      "classDetails": "Class Details",
      "riderDetails": "Rider Details",
      "riderProfile": "Rider Profile",
      "volunteerAttendance": "Volunteer Attendance",
      "riderPairing": "Rider Paring",
      "personalInfo": "Personal Information",
      "websiteTerms": "Website Terms and Privacy Policy",
      "logout": "Logout"
    },
    "personalInfo": {
      "title": "Personal Information",
      "name": "Name",
      "mobile": "Mobile",
      "dateOfBirth": "Date of Birth",
      "joinDate": "Join Date",
      "emergencyName": "Emergency Name",
      "emergencyMobile": "Emergency Mobile",
      "grade": "Grade"
    },
    "schedule": {
      "upcomingClass": "Upcoming class",
      "week": {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday"
      },
      "noClass": "No Class"
    },
    "details": {
      "gender": "GENDER",
      "male": "Male",
      "female": "Female",
      "dateOfBirth": "Date of Birth",
      "age": "Age",
      "yearsOld": "Years old",
      "height": "HEIGHT",
      "weight": "WEIGHT",
      "headSize": "HEAD SIZE",
      "school": "SCHOOL",
      "disability": "DIAGNOSIS",
      "remark": "Remark",
      "leaveType": {
        "sick": "Sick Leave",
        "casual": "Casual Leave"
      },
      "physicalAbility": "Physical Ability",
      "walk": "Walk",
      "medication": "MEDICATION",
      "previousRidingExperience": "PREVIOUS RIDING EXPERIENCE",
      "others": "Others",
      "volunteerAssigned": "Volunteer Assigned",
      "assignedTask": "Assigned Task",
      "equipmentAssigned": "Equipment Assigned",
      "horseAssigned": "Horse Assigned",
      "unitRiders": "Riders",
      "riders": "Riders",
      "yes": "YES",
      "no": "NO",
      "agreeTakePhoto": "Agree to take photos",
      "disagreeTakePhoto": "Disagree to take photos",
      "confirmRidersAttendance": "Confirm rider's attendance",
      "confirmVolunteersAttendance": "Confirm Volunteer's attendance",
      "pairHorseEquipmentVolunteerWithRider": "Pair Horse, Equipment, Volunteer with Rider",
      "undefined": "",
      "noDisability": "No Disability",
      "noMedication": "No Medication",
      "noExperience": "No Experience",
      "leader": "Leader",
      "sideHelper": "Side Helper",
      "notAssigned": "Not Assigned",
      "informationShownOnVolunteerCoach": "Information shown on Volunteer – Coach",
      "informationShownOnVolunteer": "Information shown on Volunteer",
      "term": "TERM",
      "day": "DAY",
      "time": "TIME",
      "riderFullName": "RIDER'S FULL NAME",
      "nationality": "NATIONALITY",
      "languageUsed": "Language used",
      "photographsFilmingConsent": "PHOTOGRAPHS / FILMING CONSENT",
      "walkingAids": "WALKING AIDS"
    },
    "availability": {
      "days": "Days",
      "time": "Time",
      "yourSelections": "Your Selections",
      "submit": "Submit",
      "am": "AM",
      "pm": "PM",
      "noAnyRecords": "No any records",
      "timeslotUpdateSuccessfully": "Prefered Timeslots Updated"
    },
    "class": {
      "termRide": "Term Ride",
      "independentRide": "Independent Ride",
      "groupRide": "Group Ride"
    },
    "disability": {
      "autismSpectrumDisorders": "Autism Spectrum Disorders",
      "attentionDeficitAndHyperactivityDisorder": "Attention Deficit And Hyperactivity Disorder",
      "specificLearningDifficulties": "Specific Learning Difficulties",
      "intellectualDisability": "Intellectual Disability",
      "communicationDifficulties": "Communication Difficulties",
      "visualImpairment": "Visual Impairment",
      "hearingImpairment": "Hearing Impairment",
      "behavioralAndEmotionalDifficulties": "Behavioral And Emotional Difficulties",
      "physicalDisability": "Physical Disability",
      "others": "Others"
    },
    "mobility": {
      "independent": "Independent",
      "assistanceNeeded": "Assistance Needed",
      "unaided": "Unaided",
      "crutches": "Crutches",
      "walkingStick": "Walking Stick",
      "walker": "Walker",
      "wheelchair": "Wheelchair",
      "others": "Others"
    },
    "leaveRequest": {
      "all": "All",
      "pending": "Pending",
      "approved": "Recorded",
      "appliedDate": "Applied Date",
      "type": "Type",
      "leaveType": {
        "sick": "Sick",
        "casual": "Casual"
      },
      "newLeaveRequest": "New Leave Request",
      "pleaseSelectYourClass": "Please select your class",
      "noAnyRecords": "No any records",
      "submit": "Submit",
      "leaveRequestAddedSuccessfully": "Leave Request Added",
      "mins": "mins"
    },
    "accountSetting": {
      "updatePassword": "Update Password",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm Password",
      "showPassword": "Show Password",
      "submit": "Submit",
      "cancel": "Cancel",
      "passwordRequired": "Password is required.",
      "passwordNotMatch": "Password not match.",
      "passwordAtLeast6Char": "Password at least 6 characters.",
      "pleaseFill": "Please fill",
      "passwordUpdateSuccessfully": "Password has been changed successfully",
      "originPasswordIncorrect": "Origin password is incorrect"
    },
    "assessment": {
      "assessment": "Assessment",
      "communication": "Communication",
      "select": "Select",
      "confident": "Confident",
      "enjoyment": "Enjoyment",
      "horsemanship": "Horsemanship",
      "physicalChange": "Physical Change",
      "submit": "Submit",
      "assessmentUpdateSuccessfully": "Assessment Updated",
      "confirm": "Confirm",
      "assessor": "Assessor",
      "confirmer": "Confirmer",
      "confirmTitle": "Confirm Assessment",
      "confirmMessage": "Once submitted, the assessment information cannot be modified. Are you sure you want to submit this assessment?",
      "cancel": "Cancel"
    },
    "volunteerAttendance": {
      "name": "Name",
      "attendance": "Attendance status",
      "confirm": "Confirm",
      "present": "Present",
      "absent": "Absent",
      "late": "Late",
      "excused": "Excused",
      "noVolunteer": "No Volunteer",
      "attendanceUpdateSuccessfully": "Volunteer Attendance Status Updated"
    },
    "riderPairing": {
      "volunteer": "Volunteer",
      "selectVolunteer": "Select Volunteer",
      "leader": "Leader",
      "sideHelper": "Side Helper",
      "submit": "Submit",
      "equipment": "Equipment",
      "selectEquipment": "Select Equipment",
      "horse": "Horse",
      "selectHorse": "Select Horse",
      "pairingUpdateSuccessfully": "Pairings Updated"
    },
    "errorMsg": {
      "Current password is incorrect": "Orginal password is incorrect",
      "The new password must be at least 8 characters.": "The new password must be at least 8 characters."
    },
    "register": {
      "register": "Register",
      "seeTheDateTime": "See the date & time",
      "tuenMunPublicRidingSchool": "Tuen Mun Public Riding School",
      "tuenMunPublicRidingSchoolAddress": "Lot 45, Lung Mun Road, Tuen Mun, N.T.",
      "pokfulamPublicRidingSchool": "Pokfulam Public Riding School",
      "pokfulamPublicRidingSchoolAddress": "75 Pokfulam Reservoir Road, Pokfulam, H.K.",
      "leiYueMunPublicRidingSchool": "Lei Yue Mun Public Riding School",
      "leiYueMunPublicRidingSchoolAddress": "75 Chai Wan Road, Chai Wan, H.K.",
      "monToFri": "Mon-Fri",
      "monToSat": "Mon – Sat",
      "monToWedFri": "Mon – Wed, Fri",
      "part": "Part",
      "sat": "Sat",
      "wedAndFri": "Wed & Fri",
      "tueAndThu": "Tue & Thu",
      "am": "AM",
      "pm": "PM",
      "back": "Back",
      "next": "Next",
      "yes": "Yes",
      "no": "No",
      "confirm": "Confirm",
      "pleaseEnter": "Please enter.",
      "pleaseSelect": "Please select.",
      "email": "Email",
      "password": "Password",
      "confirmPassword": "Confirm Password",
      "showPassword": "Show Password",
      "englishName": "English Name",
      "chineseName": "Chinese Name",
      "gender": "Gender",
      "male": "Male",
      "female": "Female",
      "dateOfBirth": "Date of Birth",
      "idCardNo": "ID Card No.",
      "phoneNumber": "Phone Number",
      "occupation": "Occupation",
      "address": "Address",
      "registerSuccessfully": "Register Successfully",
      "privacyRegisterRequired": "Upon registration, user needs to review the use of Terms & Conditions and Privacy Policy, scroll down and accept it",
      "fullName": "Full Name",
      "relationship": "Relationship",
      "expRFD": "Experience with Riding For The Disabled",
      "RHExp": "Riding/Horse Experience",
      "medExp": "Medical Experience",
      "knowAndExp": {
        "label": "Knowledge and Experience",
        "pvMaking": "Photography/Video Making",
        "workWithChild": "Working with Children",
        "workWithPD": "Working with people with disabilities",
        "media": "Media"
      },
      "howDidFind": {
        "label": "How did you find out about RDA Hong Kong?",
        "rdaHKWebsite": "RDA HK Website",
        "rdaFacebook": "RDA Facebook",
        "searchEngine": "Search Engine",
        "friends": "Friends",
        "others": "Others (Please Specify)"
      },
      "contactNumber": "Contact Number",
      "relWithReferer": "Relationship with referer",
      "declaration1": "I hereby declare that I undertake to be a volunteer helper at my own risk. I accept full responsibility for my actions and behaviour when attending RDA sessions. Please note that RDA Hong Kong may take photos or videos during the volunteering session and or RDA events for publicity purposes.",
      "declaration2": "I agree to abide RDA Children and Vulnerable Adults Safeguarding Policy and Volunteer Guidelines during the volunteering session and or RDA events.",
      "iAgreeTo": "I agree to",
      "consentRaR": "RDA rules and regulation",
      "consentVWG": "Volunteer Work Guide",
      "consentIF2016": "RDA indemnity Form 2016",
      "personalInformation": "Personal Information",
      "emergencyContact": "Emergency Contact",
      "locationPreference": "Location Preference",
      "locationPreferenceTip": "Select the preferred location (can be more than one)",
      "knowledgeExperience": "Knowledge and Experience",
      "knowledgeExperienceTip": "The following information helps us to bring your knowledge and experience into full play. Kindly tell us what you would like to do!",
      "volunteerReferralScheme": "RDA Volunteer Referral Scheme (If applicable)",
      "declarationConsent": "Declaration and Consent",
      "declarationTip": "Please check below boxes to confirm your application",
      "consentTip": "Please tick below boxes to indicate your consent"
    }
  },
  "validation": {
    "passwordPattern": "At least 8 characters, including at least one symbol, lowercase and uppercase.",
    "phoneMinDigits": "Enter at least 8 digits"
  },
  "FOOTER": {
    "TUEN_MUN": "Tuen Mun Public Riding School",
    "POKFULAM": "Pokfulam Public Riding School",
    "TEL": "Tel: ",
    "EMAIL": "E-mail: ",
    "WEBSITE": "Website: ",
    "CHARITY_REG": "Charity Reg. No.: ",
    "COPYRIGHT": "Riding for the Disabled Association Ltd. All Rights Reserved.",
    "COPYRIGHT_ORG": "Riding for the Disabled Association Ltd.",
    "COPYRIGHT_ORG_ZH": "香港傷健策騎協會有限公司版權所有",
    "COPYRIGHT_RESERVED": "All Rights Reserved."
  },
  "consentCVASP": "RDA Children and Vulnerable Adults Safeguarding Policy",
  "consentRaR": "RDA rules and regulation",
  "consentVWG": "Volunteer Work Guide",
  "consentIF2016": "RDA indemnity Form 2016"
}
